import React from 'react'
import Link from 'gatsby-link'
import { SkillsCourses, SkillsDescription, Timeline, SkillsCharts } from "../components/skills";
import { Footer } from '../components/Footer';
const SkillsPage = () => (
    <div className="skills-wrapper">
        <SkillsDescription></SkillsDescription>
        <Timeline></Timeline>
        <SkillsCharts></SkillsCharts>
        <SkillsCourses></SkillsCourses>
        <Footer />
    </div>
);

export default SkillsPage;



// WEBPACK FOOTER //
// ./src/pages/skills.js